import { unset } from 'cerebral/operators'

export default [unset('client.delete.user')]



// WEBPACK FOOTER //
// ./src/modules/user/chains/preventDelete.js